// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SitesByTenantRequestModel {
    static getAttributeTypeMap() {
        return SitesByTenantRequestModel.attributeTypeMap;
    }
}
SitesByTenantRequestModel.discriminator = undefined;
SitesByTenantRequestModel.additionalProperties = false;
SitesByTenantRequestModel.attributeTypeMap = [
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
];
//# sourceMappingURL=sitesByTenantRequestModel.js.map